// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) { return "styles" + "." + "4a80c2569df0d89506be" + ".css"; };